<ng-container *ngIf="loaded">
  <span *ngIf="readonlyOnEdit && hasId; else dropdown">
    {{ readonlyDisplayValue || "—" }}
  </span>

  <ng-template #dropdown>
    <thera-dropdown
      [class.highlight]="!!hint"
      [options]="dropdownOptions"
      [required]="required"
      [defaultSelection]="value"
      [isDisabled]="disabled"
      [hint]="hint"
      (optionSelected)="onOptionSelected($any($event))"
      (focus)="onFocus()"
      style="width: 100%"
    ></thera-dropdown>
  </ng-template>
</ng-container>

<span 
  class="text-danger" 
  *ngIf="required && isRequired && !isTouched && !isOptionSelected  && !value "  
  [ngClass]="getWarningClass()">
  {{ requiredText }}
</span>
